module.exports = __webpack_public_path__ + "img/ico_dependentes.74befbcb.svg";